const Vendors = (() => {
    var vendorTable;
    var vendorId;   
    var validationRules = [
        { fieldId: 'vendorName', required: true, expression: /^(?=.*\S).{1,60}$/ },
        { fieldId: 'contactName', required: false, expression: /^(?=.*\S).{0,100}$/ },
        { fieldId: 'firstName', required: false, expression: /^(?=.*\S).{0,40}$/ },
        { fieldId: 'lastName', required: false, expression: /^(?=.*\S).{0,80}$/ },
        { fieldId: 'vendorShortName', required: false, expression: /^(?=.*\S).{0,10}$/ },
        { fieldId: 'contactEmail', required: false, expression: /^(?=.*\S).{0,200}$/ },
        { fieldId: 'zipCode', required: false, expression: /^\d{5}(-\d{1,5})?$/ },
        { fieldId: 'phone1', required: false, expression: /^\(\d{3}\)\s\d{3}-\d{4}\s\d{4}$/ },
        { fieldId: 'phone2', required: false, expression: /^\(\d{3}\)\s\d{3}-\d{4}\s\d{4}$/ },     
        { fieldId: 'evvEmail', required: false, expression: /^(?=.*\S).{0,50}$/ },
        { fieldId: 'contractNumber', required: true, expression: /^(?=.*\S).{0,10}$/ },
        { fieldId: 'eMarUrl', required: false, expression: /^(?=.*\S).{0,500}$/ },
        { fieldId: 'provider', required: false, expression: /^(?=.*\S).{0,10}$/ },
        { fieldId: 'mhnpi', required: false, expression: /^(?=.*\S).{0,10}$/ },
        { fieldId: 'reimbursementRate', required: false, expression: /^\d{1,3}(\.\d{1,2})?$/ },
        { fieldId: 'state', required: false, expression: /^(?=.*\S).{0,2}$/ },
        { fieldId: 'certificateExpiryDate', required: false, expression: '' },
        { fieldId: 'dob', required: false, expression: '' },
        { fieldId: 'submitter', required: false, expression: /^(?=.*\S).{0,80}$/ },
        { fieldId: 'sender', required: false, expression: /^(?=.*\S).{0,80}$/ },
        { fieldId: 'address1', required: false, expression: /^(?=.*\S).{0,50}$/ },
        { fieldId: 'address2', required: false, expression: /^(?=.*\S).{0,50}$/ },
        { fieldId: 'city', required: false, expression: /^(?=.*\S).{0,30}$/ },
        { fieldId: 'ein', required: false, expression: /^(?=.*\S).{0,10}$/ },
        { fieldId: 'trFileName', required: false, expression: /^(?=.*\S).{0,8}$/ },
        { fieldId: 'glCode', required: false, expression: /^(?=.*\S).{0,50}$/ },
        { fieldId: 'payRollDepartment', required: false, expression: /^(?=.*\S).{0,50}$/ },
        { fieldId: 'cashAccount', required: false, expression: /^(?=.*\S).{0,50}$/ },
        { fieldId: 'glInterface', required: false, expression: /^(?=.*\S).{0,50}$/ },
        { fieldId: 'receivableAccount', required: false, expression: /^(?=.*\S).{0,50}$/ },
        { fieldId: 'custom', required: false, expression: /^(?=.*\S).{0,40}$/ },
        { fieldId: 'exportTo', required: false, expression: /^(?=.*\S).{0,100}$/ },
        { fieldId: 'importFrom', required: false, expression: /^(?=.*\S).{0,100}$/ },
        { fieldId: 'evvUserID', required: false, expression: /^(?=.*\S).{0,50}$/ },
        { fieldId: 'evvPassword', required: false, expression: /^(?=.*\S).{0,20}$/ },
        { fieldId: 'evvID', required: false, expression: /^(?=.*\S).{0,10}$/ },
        { fieldId: 'eMARUserID', required: false, expression: /^(?=.*\S).{0,500}$/ },
        { fieldId: 'eMARPassword', required: false, expression: /^(?=.*\S).{0,500}$/ },
        { fieldId: 'localID', required: false, expression: /^(?=.*\S).{0,20}$/ },
        { fieldId: 'buildingNumber', required: false, expression: /^(?=.*\S).{0,40}$/ },
        { fieldId: 'primaryCountry', required: false, expression: /^(?=.*\S).{0,15}$/ },
    ];

    var yesOrNoDropdownData = [
        { text: 'Yes', value: 'Y' },
        { text: 'No', value: 'N' }
    ];
    var reimbursementPositiveOrNegativeDropdownData = [
        { text: 'Positive', value: 'P' },
        { text: 'Negative', value: 'N' }
    ];
    var reimbursementTypesDropdownData = [
        { text: 'Deduction', value: 'D'},
        { text: 'Earning', value: 'E' }
    ];
    var payrollInterfaces = [       
        { "text": "Absolute", "value": "Absolute" },
        { "text": "Absolute Flex", "value": "Absolute Flex" },
        { "text": "Accessible - Paychex", "value": "Accessible - Paychex" },
        { "text": "ADD", "value": "ADD" },
        { "text": "ADP", "value": "ADP" },
        { "text": "Alvis House", "value": "Alvis House" },
        { "text": "Brooks", "value": "Brooks" },
        { "text": "Brooks - RFW", "value": "Brooks - RFW" },
        { "text": "Cap City - Paychex", "value": "Cap City - Paychex" },
        { "text": "Clermont", "value": "Clermont" },
        { "text": "Community Options", "value": "Community Options" },
        { "text": "CORE - ADP", "value": "CORE - ADP" },
        { "text": "Creative Foundations", "value": "Creative Foundations" },
        { "text": "CRSI", "value": "CRSI" },
        { "text": "CSS", "value": "CSS" },
        { "text": "DBase II", "value": "DBase II" },
        { "text": "EASTER", "value": "EASTER" },
        { "text": "Easter TriState", "value": "Easter TriState" },
        { "text": "ECI - Paycom", "value": "ECI - Paycom" },
        { "text": "Embracing Autism", "value": "Embracing Autism" },
        { "text": "Embracing Autism Ultipro", "value": "Embracing Autism Ultipro" },
        { "text": "Excel", "value": "Excel" },
        { "text": "FCRS", "value": "FCRS" },
        { "text": "Fuse Network", "value": "Fuse Network" },
        { "text": "GAMYS - ADP", "value": "GAMYS - ADP" },
        { "text": "Gazelle - Paychex", "value": "Gazelle - Paychex" },
        { "text": "Goodwill", "value": "Goodwill" },
        { "text": "Goodwill Ceridian", "value": "Goodwill Ceridian" },
        { "text": "Guided Care - Paycor", "value": "Guided Care - Paycor" },
        { "text": "Havar", "value": "Havar" },
        { "text": "Help", "value": "Help" },
        { "text": "HIS", "value": "HIS" },
        { "text": "Home Health", "value": "Home Health" },
        { "text": "Home Health Paycor", "value": "Home Health Paycor" },
        { "text": "Home Health Ultipro", "value": "Home Health Ultipro" },
        { "text": "Home Watch", "value": "Home Watch" },
        { "text": "Hopewell", "value": "Hopewell" },
        { "text": "I Am Boundless", "value": "I Am Boundless" },
        { "text": "Leeda - IFS", "value": "Leeda - IFS" },
        { "text": "LICCO", "value": "LICCO" },
        { "text": "LIFE - Amplify", "value": "LIFE - Amplify" },
        { "text": "Mercer", "value": "Mercer" },
        { "text": "Navision", "value": "Navision" },
        { "text": "OVGI", "value": "OVGI" },
        { "text": "Paychex", "value": "Paychex" },
        { "text": "Paychex Flex", "value": "Paychex Flex" },
        { "text": "Paychex Flex - With Expenses", "value": "Paychex Flex - With Expenses" },
        { "text": "Paycom With Mileage", "value": "Paycom With Mileage" },
        { "text": "Paycom With Mileage - CF", "value": "Paycom With Mileage - CF" },
        { "text": "Paycor No Mileage", "value": "Paycor No Mileage" },
        { "text": "Paylocity", "value": "Paylocity" },
        { "text": "PDP", "value": "PDP" },
        { "text": "PDP ADP", "value": "PDP ADP" },
        { "text": "Plans to Prosper - Candoor", "value": "Plans to Prosper - Candoor" },
        { "text": "Quickbooks Pro", "value": "Quickbooks Pro" },
        { "text": "Reflektions", "value": "Reflektions" },
        { "text": "RHAMADP", "value": "RHAMADP" },
        { "text": "RHC", "value": "RHC" },
        { "text": "Sandco", "value": "Sandco" },
        { "text": "Sandco2", "value": "Sandco2" },
        { "text": "Scioto Trails - Smartlinx", "value": "Scioto Trails - Smartlinx" },
        { "text": "SCL", "value": "SCL" },
        { "text": "Solana", "value": "Solana" },
        { "text": "TBC Portage", "value": "TBC Portage" },
        { "text": "Text (Tab Delimited)", "value": "Text (Tab Delimited)" },
        { "text": "UDS", "value": "UDS" },
        { "text": "Upreach", "value": "Upreach" }
    ];
    var payrollCodes = [];
    var defaultDropdownOption = { value: '', text: '' };         
    payrollInterfaces.unshift(defaultDropdownOption);   
   
    async function populateVendorTable() {
        const vendorListResult = await _UTIL.fetchData('getVendorList', { token: $.session.Token }); 
        const vendorList = vendorListResult.getVendorListResult || [];       
        const tableData = vendorList.map(key => {
            return {
                id: key.vendorID,
                values: [key.vendorName, key.vendorShortName, key.contractNumber, key.provider, key.active],
                attributes: [{ key: 'data-referenced', value: key.referenced }],
                endIcon: $.session.SetupDelete === true ? icons['delete'] : icons['empty'],
                endIconCallback: e => {
                    e.stopPropagation();
                    if ($.session.SetupDelete === true) {
                        var tr = e.target.closest('div.table__row');
                        if (tr.getAttribute('data-referenced') === 'Y') {
                            showAlreadyExistsWarning('This vendor cannot be deleted, because it is associated to a region.');
                        }
                        else {
                            showDeleteWarning(tr.id);
                        }
                    }
                },
                onClick: async e => {
                    if (!e.target.classList.contains('endIcon')) {
                        showProgressPopup('Loading Vendor Details...');
                        vendorId = e.target.id;
                        const VendorById = await _UTIL.fetchData('getVendorById', { token: $.session.Token, vendorId: vendorId });
                        const vendorData = VendorById.getVendorByIdResult;     
                        hideProgressPopup();
                        showVendorForm();                       
                        setUpEvents();
                        setPasswordFieldEyeIconAndEvents();                        
                        const inputs = document.querySelectorAll("input, select");
                        inputs.forEach(input => {
                            let fieldValue = vendorData[input.id]?.trim()||null;
                            if ((input.id === 'certificateExpiryDate' || input.id === 'dob') && fieldValue) {
                                fieldValue = moment(fieldValue).format("YYYY-MM-DD");
                                
                            }
                            if ((input.id === 'vendorName' || input.id === 'contractNumber') && fieldValue) {
                                input.classList.remove('error');
                            }
                            if (!$.session.SetupUpdate) {
                                input.classList.add('disabled');
                                input.disabled = true;
                            }                          
                            input.value = fieldValue;                            
                        });

                        const localVendor = document.getElementById('localVendor');
                        if (vendorData["localVendor"] === 'N') {
                            localVendor.parentElement.style.width = '48%';
                        }
                        else {
                            localVendor.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                        
                        document.getElementById('zipCode').dispatchEvent(new Event('blur', { bubbles: true }));
                        document.getElementById('zipCode').dispatchEvent(new Event('change', { bubbles: true }));
                        document.getElementById('phone1').dispatchEvent(new Event('blur', { bubbles: true }));
                        document.getElementById('phone2').dispatchEvent(new Event('blur', { bubbles: true }));   

                        document.querySelectorAll("input, select").forEach(el => {
                            el.setAttribute('initial-value', el.value);
                        });
                        
                        toggleSaveBtnStatus();
                       
                    }                  
                },
            }
        });
        table.populate(vendorTable, tableData);
    }
    function showAlreadyExistsWarning(msg) {
        var warningPopup = POPUP.build({});
        warningPopup.classList.add('warning');
        var message = document.createElement('p');
        message.innerHTML = msg;
        message.style.marginBottom = '15px';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        var okBtn = button.build({
            text: 'Ok',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(warningPopup);
                const saveBtn = document.getElementById('saveBtn');
                const cancelBtn = document.getElementById('cancelBtn');               
                if (saveBtn && cancelBtn) {
                    const overlay = document.querySelector('.overlay');
                    overlay.classList.add('visible');
                    saveBtn.classList.remove('disabled');
                    cancelBtn.classList.remove('disabled');
                }
            }
        });
       
        btnWrap.appendChild(okBtn);       
        warningPopup.appendChild(message);
        warningPopup.appendChild(btnWrap);
        POPUP.show(warningPopup);
        warningPopup.querySelector('.closePopupBtn').remove();
    }
    function showDeleteWarning(vendorId) {        
        var deleteWarningPopup = POPUP.build({});
        var message = document.createElement('p');
        message.innerHTML = 'Are you sure you want to delete this vendor?';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        btnWrap.style.marginTop = '25px';
        var yesBtn = button.build({
            text: 'Yes',
            type: 'contained',
            style: 'secondary',
            callback: async () => {
                POPUP.hide(deleteWarningPopup);
                showProgressPopup('Deleting Vendor...');
                const result = await _UTIL.fetchData('deleteVendor', { token: $.session.Token, vendorId: vendorId });
                const deleteResult = result.deleteVendorResult;  
                hideProgressPopup();
                if (deleteResult && deleteResult === 'success') {                   
                    successfulSave.show('Deleted');
                    await populateVendorTable();
                    setTimeout(() => { successfulSave.hide(); }, 2000);
                }
                else {
                    failSave.show('An error occured.');
                    setTimeout(() => { failSave.hide(); }, 2000);
                    return;
                }
            }
        });
        var noBtn = button.build({
            text: 'No',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(deleteWarningPopup);
            }
        });
        btnWrap.appendChild(yesBtn);
        btnWrap.appendChild(noBtn);
        deleteWarningPopup.appendChild(message);
        deleteWarningPopup.appendChild(btnWrap);
        POPUP.show(deleteWarningPopup);
    }
    function showProgressPopup(message) {
        pageLoadPopup = POPUP.build({
            hideX: true,
        });
        pageLoadPopup.style.minHeight = '40%';

        // magic to make overlay cover entire site for this once instance
        const overlayDiv = document.querySelector('div.overlay');
        const menuDiv = document.querySelector('div.module-menu');
        overlayDiv.style.zIndex = '100';
        menuDiv.style.zIndex = '99';

        const spinner = PROGRESS.SPINNER.get(message);
        spinner.style.display = 'block';
        pageLoadPopup.appendChild(spinner);
        POPUP.show(pageLoadPopup);
    }
    function hideProgressPopup() {
        const overlayDiv = document.querySelector('div.overlay');
        const menuDiv = document.querySelector('div.module-menu');
        overlayDiv.style.zIndex = '30';
        menuDiv.style.zIndex = '100';
        POPUP.hide(pageLoadPopup);
    }
    function createGrid(elements,grouped) {
        var grid = document.createElement('div');
        grid.classList.add('grid');
        var group = document.createElement('div');
        group.classList.add('grouped');       
        elements?.forEach(function (elem, index) {
            let grpIndex = grouped?.indexOf(index);
            if (grpIndex >= 0) {               
                group.appendChild(elem.rootElement);
                if (grpIndex % 2 > 0 || grouped?.length === 1) {
                    if (grouped?.length === 1) {
                        group.style.width = '48%';
                    }
                    grid.appendChild(group);
                    group = document.createElement('div');
                    group.classList.add('grouped');
                }
            }
            else {
                grid.appendChild(elem.rootElement);
            }
        });      
        return grid;
    }
    function createHeading(heading) {
        const header = document.createElement('h3');
        header.classList.add('heading');
        header.textContent = heading;
        return header;
    }
    function showVendorForm(data) {

        const nameInput = new Input({ label: 'Name*', type: 'text', value: '', id: 'vendorName', maxlength: 60 });
        const shortNameInput = new Input({ label: 'Short Name', type: 'text', value: '', id: 'vendorShortName', maxlength: 10 });
        const contactInput = new Input({ label: 'Contact', type: 'text', value: '', id:'contactName', maxlength: 100 });
        const emailInput = new Input({ label: 'Email', type: 'text', value: '', id: 'contactEmail', maxlength: 200 });
        const addressInput1 = new Input({ label: 'Address1', type: 'text', value: '', id:'address1', maxlength: 50 });
        const addressInput2 = new Input({ label: 'Address2', type: 'text', value: '', id:'address2', maxlength: 50 });
        const cityInput = new Input({ label: 'City', type: 'text', value: '', id:'city', maxlength: 30 });
        const stateInput = new Input({ label: 'State', type: 'text', value: '', id: 'state', maxlength: 2 });        
        const zipInput = new Input({ label: 'Zip Code', type: 'text', value: '', id: 'zipCode', maxlength: 10 });      
        const phoneInput1 = new Input({ label: 'Phone1', type: 'text', value: '', id: 'phone1', maxlength: 19});
        const phoneInput2 = new Input({ label: 'Phone2', type: 'text', value: '', id: 'phone2', maxlength: 19 });       
        const agencyDropDown = new Select({ label: 'Agency?', data: yesOrNoDropdownData, id:'agency' });
        agencyDropDown.setValue(data?.agency);
        const certificationExpirationDate = new Input({ label: 'Certification Expiration Date', type: 'Date', value: '', id: 'certificateExpiryDate' });
        const contractInput = new Input({ label: 'Contract #*', type: 'text', value: '', id: 'contractNumber', maxlength:10 });
        const submitterInput = new Input({ label: 'Submitter ID', type: 'text', value: '', id: 'submitter', maxlength: 80 });
        const providerInput = new Input({ label: 'Provider #', type: 'text', value: '', id:'provider', maxlength: 10 });
        const einInput = new Input({ label: 'EIN', type: 'text', value: '', maxlength: 10, id: 'ein', maxlength: 10 });
        const mhnpiInput = new Input({ label: 'MH NPI#', type: 'text', value: '', id:'mhnpi', maxlength: 10 });
        const senderInput = new Input({ label: 'Sender ID', type: 'text', value: '', id: 'sender', maxlength: 80 });
        const fileNameInput = new Input({ label: 'Transmission File Name', type: 'text', value: '', id: 'trFileName', maxlength: 8 });
        const salesForceIDInput = new Input({ label: 'Salesforce ID', type: 'text', value: '', id:'salesForceID', readonly:"readonly" });
        const glCodeInput = new Input({ label: 'G/L Code', type: 'text', value: '', id: 'glCode', maxlength: 50 });
        const payRollDeptInput = new Input({ label: 'Payroll Department', type: 'text', value: '', id: 'payRollDepartment', maxlength: 50 });
        const cashAccountInput = new Input({ label: 'Cash Account', type: 'text', value: '', id: 'cashAccount', maxlength: 50 });
        const glInterfaceInput = new Input({ label: 'G/L Interface', type: 'text', value: '', id: 'glInterface', maxlength: 50 });
        const receivableAccountInput = new Input({ label: 'Receivable Account', type: 'text', value: '', id: 'receivableAccount', maxlength: 50 });
        const payrollInterfaceDropDown = new Select({ label: 'Payroll Interface', id: 'payRollInterface', data: payrollInterfaces });
        const customInput = new Input({ label: 'Custom', type: 'text', value: '', id: 'custom', maxlength: 40 });
        const updateToPayrollDropDown = new Select({ label: 'Update Employee Info To Payroll', data: yesOrNoDropdownData, id:'updateToPayroll' });
        updateToPayrollDropDown.setValue(data?.updateToPayRoll);
        const reimbursementRateInput = new Input({ label: 'Mileage Reimbursement Rate', type: 'text', value: '', id: 'reimbursementRate' });
        const reimbursementWorkCodeDropDown = new Select({ label: 'Mileage Reimbursement Work Code', id: 'reimbursementWorkCode', data: payrollCodes });
        const reimbursementTypeDropDown = new Select({ label: 'Mileage Reimbursement Type', id: 'reimbursementType', data: reimbursementTypesDropdownData });
        reimbursementTypeDropDown.setValue(data?.reimbursementType);
        const reimbursementPostOrNegtDropDown = new Select({ label: 'Mileage Reimbursement -/+', data: reimbursementPositiveOrNegativeDropdownData, id:'reimbursementPositiveorNegative' });
        reimbursementPostOrNegtDropDown.setValue(data?.reimbursementPositiveOrNegative)
        const exportToInput = new Input({ label: 'Export To', type: 'text', value: '', id: 'exportTo', maxlength: 100 });
        const importFromInput = new Input({ label: 'Import From', type: 'text', value: '', id: 'importFrom', maxlength: 100 });
        const evvUserIDInput = new Input({ label: 'EVV User ID', type: 'text', value: '', id: 'evvUserID', maxlength: 50 });       
        const evvPswdInput = new Input({ label: 'EVV Password', type: 'password', value: '', id: 'evvPassword', maxlength: 20, autocomplete:'new-password' });        
        const evvEmailInput = new Input({ label: 'EVV Email Address', type: 'text', value: '', id: 'evvEmail', maxlength: 50 });
        const sendEVVDataDropDown = new Select({ label: 'Send EVV Data?', data: yesOrNoDropdownData, id:'sendEvvData' });
        sendEVVDataDropDown.setValue(data?.sendEvvData);
        const evvIDInput = new Input({ label: 'EVV#', type: 'text', value: '', id: 'evvID', maxlength: 10 });
        const eMarUserIDInput = new Input({ label: 'eMAR User ID', type: 'text', value: '', id: 'eMARUserID', maxlength: 500 });
        const eMarPswdInput = new Input({ label: 'eMAR Password', type: 'password', value: '', id: 'eMARPassword', maxlength: 500, autocomplete: 'new-password' });
        const eMarURLInput = new Input({ label: 'eMAR URL', type: 'text', value: '', id: 'eMarUrl',  maxlength: 500 });
        const localVendorDropDown = new Select({ label: 'Local Vendor?', data: yesOrNoDropdownData, id:'localVendor' });
        localVendorDropDown.setValue(data?.localVendor);
        const localIDInput = new Input({ label: 'Local#', type: 'text', value: '', id: 'localID', maxlength: 20 });
        const firstnameInput = new Input({ label: 'First Name', type: 'text', value: '', id: 'firstName',  maxlength: 40 });
        const lastnameInput = new Input({ label: 'Last Name', type: 'text', value: '', id: 'lastName', maxlength: 80 });
        const dobDate = new Input({ label: 'Date Of Birth', type: 'Date', value: '',id:'dob' });
        const buildingNumberInput = new Input({ label: 'Building Number', type: 'text', value: '', id: 'buildingNumber', maxlength: 40 });
        const countryInput = new Input({ label: 'Primary County(e.g. DELA)', type: 'text', value: '', id: 'primaryCountry', maxlength: 15 });
        showOrHideVendorFields(data?.localVendor);       
        localVendorDropDown.rootElement.addEventListener('change', (e) => {
            showOrHideVendorFields(e.target.value);
        });
        function showOrHideVendorFields(isLocalVendor) {
            let localVendor = document.getElementById('localVendor');
            if (isLocalVendor === 'Y') {
                localIDInput.rootElement.classList.remove('hidden');
                firstnameInput.rootElement.classList.remove('hidden');
                lastnameInput.rootElement.classList.remove('hidden');
                dobDate.rootElement.classList.remove('hidden');
                buildingNumberInput.rootElement.classList.remove('hidden');
                countryInput.rootElement.classList.remove('hidden');
                if (localVendor) {
                    localVendor.parentElement.style.width = '';
                }
            }
            else {

                localIDInput.rootElement.classList.add('hidden');
                firstnameInput.rootElement.classList.add('hidden');
                lastnameInput.rootElement.classList.add('hidden');
                dobDate.rootElement.classList.add('hidden');
                buildingNumberInput.rootElement.classList.add('hidden');
                countryInput.rootElement.classList.add('hidden');
                if (localVendor) {
                    localVendor.parentElement.style.width = '48%';
                }
            }
        }

        const popup = POPUP.build({
            classNames: 'vendorClassPopup',
        });
       
        const container = document.createElement('div');
        container.id = 'vendorForm';      
     
        container.appendChild(createGrid([nameInput, shortNameInput]));
        container.appendChild(createGrid([contactInput, emailInput]));
        container.appendChild(createGrid([addressInput1, addressInput2]));
        container.appendChild(createGrid([cityInput, stateInput, zipInput],[1,2]));
        container.appendChild(createGrid([phoneInput1, phoneInput2]));
        container.appendChild(createGrid([agencyDropDown, certificationExpirationDate], [0, 1]));
        container.appendChild(createHeading('Identification Numbers'));
        container.appendChild(createGrid([contractInput, submitterInput, providerInput, einInput],[0,1,2,3]));
        container.appendChild(createGrid([mhnpiInput, senderInput, fileNameInput, salesForceIDInput], [0, 1, 2, 3]));
        container.appendChild(createHeading('Accounting and Payroll'));
        container.appendChild(createGrid([glCodeInput, payRollDeptInput, cashAccountInput, glInterfaceInput], [0, 1, 2, 3]));
        container.appendChild(createGrid([receivableAccountInput, payrollInterfaceDropDown, customInput, updateToPayrollDropDown], [0, 1, 2, 3]));
        container.appendChild(createGrid([reimbursementRateInput, reimbursementWorkCodeDropDown, reimbursementTypeDropDown, reimbursementPostOrNegtDropDown], [0, 1, 2, 3]));
        container.appendChild(createGrid([exportToInput, importFromInput], [0,1]));
        container.appendChild(createHeading('EVV'));
        container.appendChild(createGrid([evvUserIDInput, evvPswdInput, evvEmailInput, sendEVVDataDropDown], [0, 1, 2, 3]));
        container.appendChild(createGrid([evvIDInput], [0]));
        container.appendChild(createHeading('SimpleMAR'));
        container.appendChild(createGrid([eMarUserIDInput, eMarPswdInput, eMarURLInput], [0, 1]));
        container.appendChild(createHeading('Ohio ISP'));
        container.appendChild(createGrid([localVendorDropDown, localIDInput, firstnameInput, lastnameInput], [0, 1, 2, 3]));
        container.appendChild(createGrid([dobDate, buildingNumberInput, countryInput], [0, 1]));
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        const saveBtn = button.build({
            id:'saveBtn',
            text: ' Save',
            icon:['save'],
            style: 'secondary',
            type: 'contained',
            callback: async function (e) {
                saveBtn.classList.add('disabled');
                cancelBtn.classList.add('disabled');
                const result = await saveVendor();   
                if (result === 'success') {
                    POPUP.hide(popup);
                    successfulSave.show('Saved');
                    vendorId = 0;
                    await populateVendorTable();
                    setTimeout(() => {
                        successfulSave.hide();
                        saveBtn.classList.remove('disabled');
                        cancelBtn.classList.remove('disabled');
                    }, 2000);
                }
                else if (result === 'vendor error') {
                    showAlreadyExistsWarning('Vendor name already exists.');                   
                    return;
                }
                else if (result === 'contract error') {
                    showAlreadyExistsWarning('Contract number already exists.');                   
                    return;
                }
                else {
                    if (result === 'Error:606' || result === 'Error:607') {
                        failSave.show('Your session has expired. Please log in and try again.');
                    }
                    else {
                        failSave.show('An error occured.');
                    }
                    const overlay = document.querySelector('.overlay');
                    setTimeout(() => {
                        failSave.hide();
                        overlay.classList.add('visible');
                        saveBtn.classList.remove('disabled');
                        cancelBtn.classList.remove('disabled');
                    }, 2000);
                    return;
                }
            },
        });
        saveBtn.style.width = '125px';
        saveBtn.style.padding = '6px';
        const cancelBtn = button.build({
            id:'cancelBtn',
            text: 'Cancel',           
            style: 'secondary',
            type: 'outlined',
            callback: function (e) {
                vendorId = 0;                             
                POPUP.hide(popup);
            },
        });
        cancelBtn.style.width = '125px';
        cancelBtn.style.padding = '6px';
        if (!$.session.SetupUpdate) {
            saveBtn.classList.add('disabled');
        }
        btnWrap.appendChild(saveBtn);
        btnWrap.appendChild(cancelBtn);
        container.appendChild(btnWrap);     
        popup.appendChild(container);
        POPUP.show(popup);       
    }
    async function saveVendor() {
        showProgressPopup('Saving Vendor Details...');
        var vendorData = { vendorID: vendorId };
        const inputs = document.querySelectorAll("input, select");
        inputs.forEach(input => {         

            if (input.id === 'phone1' || input.id === 'phone2') {
                vendorData[input.id] = input.value.replace(/\D/g, '');
            }
            else {
                vendorData[input.id] = input.value;
            }
        });
        try {
            const result = await _UTIL.fetchData('saveVendor', { token: $.session.Token, vendor: vendorData });
            const saveResult = result.saveVendorResult;
            console.log(saveResult)
            hideProgressPopup();
            return saveResult;          
        }
        catch {
            hideProgressPopup();
            return 'exception'; 
        }
    }
    function setUpEvents() {       
        const inputs = document.querySelectorAll("input, select");       
        inputs.forEach(input => {
            input.addEventListener("change", (event) => {
                event.target.classList.remove('error');
                if (event.target.id) {
                    const validationRule = validationRules.filter(x => x.fieldId === event.target.id)[0] || null;                  
                    if (validationRule) {
                        if (validationRule.required === true && (!event.target.value || event.target.value === '')) {
                            event.target.classList.add('error');
                        }
                        if ((event.target.value && event.target.value !== '') && validationRule.expression !== '') {
                            var value = event.target.value;                                 
                            if (!validationRule.expression.test(value)) {                               
                                event.target.classList.add('error');                               
                            }
                            else {
                                event.target.classList.remove('error');                                
                            }                           
                        }
                        if ((event.target.id === 'certificateExpiryDate' || event.target.id === 'dob')) {
                            if (!event.target.value || event.target.value === '') {
                                event.target.classList.add('error');
                            }
                            else {
                                event.target.classList.remove('error');
                            }
                        }
                    }                   
                }
                var isChanged;
                if (!input.classList.contains('error')) {
                    const allInputs = document.querySelectorAll('#vendorForm input, #vendorForm select');
                    isChanged = Array.from(allInputs).some(el =>
                        el.getAttribute('initial-value') !== el.value
                    );
                }
                toggleSaveBtnStatus(isChanged);                
            });           
            if (input.id) {
                const isRequired = validationRules.filter(x => x.fieldId === input.id && x.required === true)[0] || null;
                if (isRequired && (!input.value || input.value === '')) {
                    input.classList.add('error');
                }
                else {
                    input.classList.remove('error');
                }
            }           
        });       
        toggleSaveBtnStatus(); 
        const phone1 = document.getElementById("phone1");
        const phone2 = document.getElementById("phone2");
        const zip = document.getElementById("zipCode");
        const state = document.getElementById("state");

        phone1.addEventListener("blur", formatPhoneOnBlur);
        phone2.addEventListener("blur", formatPhoneOnBlur);
        zip.addEventListener("blur", formatZip);
        state.addEventListener("blur", (e) => {
            e.target.value = e.target.value?.toUpperCase(); 
            e.target.dispatchEvent(new Event('change', { bubbles: true }));
        });
        state.addEventListener("input", (e) => {
            var reg = new RegExp('^[a-zA-Z]+$');
            if (!reg.test(e.target.value)) {
                e.target.value = e.target.value.substring(0, e.target.value.length - 1);
                return;
            }
        });
        [phone1, phone2, zip].forEach(field => {
            field.addEventListener('input', (e) => {                
                e.target.value = e.target.value.replace(/\D/g, '').slice(0, e.target.id === 'zipCode' ? 9 : 14);
            });
        });
       
    }    
    function formatZip(e) {
        const digits = e.target.value.replace(/\D/g, '');

        if (digits.length >= 6) {
            e.target.value = digits.slice(0, 5) + '-' + digits.slice(5, 9);           
            e.target.classList.remove('error');
            let isChanged = e.target.getAttribute('initial-value') !== e.target.value;
            toggleSaveBtnStatus(isChanged);
        }
        
    }
    function formatPhoneOnBlur(e) {
        let value = e.target.value.replace(/\D/g, "").slice(0, 14); // keep only numbers

        if (value.length >= 10) {
            let main = value.substring(0, 10);
            let ext = value.substring(10);

            let formatted =
                "(" + main.substring(0, 3) + ") " +
                main.substring(3, 6) + "-" +
                main.substring(6, 10);

            if (ext.length > 0) {
                formatted += " " + ext;
            }

            e.target.value = formatted;           
            e.target.classList.remove('error');
            let isChanged = e.target.getAttribute('initial-value') !== e.target.value;
            toggleSaveBtnStatus(isChanged);
        }       
    }   
    function toggleSaveBtnStatus(isChanged) {        
        const hasErrors = document.querySelectorAll('.error').length > 0;
        const saveBtn = document.getElementById('saveBtn');
        if (hasErrors) {
            saveBtn.classList.add('disabled');
            saveBtn.disabled = true;
        }
        else {
            saveBtn.classList.remove('disabled');
            saveBtn.disabled = false;
        }
       
        if (!saveBtn.classList.contains('disabled') && vendorId > 0 && (isChanged||false) === false) {
            saveBtn.classList.add('disabled');
            saveBtn.disabled = true;
        }
    }   
    async function getView() {
        const payrollCodesResult = await _UTIL.fetchData('getPayrollCodes');  
        payrollCodes = payrollCodesResult.getPayrollCodesResult;        
        payrollCodes.unshift(defaultDropdownOption);
      
        const viewMarkup = document.createDocumentFragment();
        vendorTable = table.build({
            tableId: 'vendorTable',
            columnHeadings: ['Name', 'Short Name', 'Contract Number', 'Provider Number', 'Active?'],
            endIcon: true
        });
        // Set the data type for each header, for sorting purposes
        const headers = vendorTable.querySelectorAll('.header div');
        headers[0].setAttribute('data-type', 'string'); // Name
        headers[1].setAttribute('data-type', 'string'); // Short Name
        headers[2].setAttribute('data-type', 'string'); // Contact Number
        headers[3].setAttribute('data-type', 'string'); // Provider Number
        headers[4].setAttribute('data-type', 'string'); // Active      

        // Call function to allow table sorting by clicking on a header.
        table.sortTableByHeader(vendorTable);

        await populateVendorTable();
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        const addNewVendorBtn = button.build({
            id:'addNewVendorBtn',
            text: 'add new vendor',
            icon:['add'],
            style: 'secondary',
            type: 'outlined',           
            callback: function (e) {
                vendorId = 0;
                showVendorForm({
                    agency: 'Y', updateToPayRoll: 'N', sendEvvData: 'N',
                    localVendor: 'N', reimbursementPositiveOrNegative: 'P',
                    reimbursementType: 'E'
                });              
                setUpEvents();
                document.getElementById('localVendor').parentElement.style.width = '48%';
                setPasswordFieldEyeIconAndEvents();

            },
        });   
        addNewVendorBtn.style.padding = '6px';
        if ($.session.SetupInsert) {
            btnWrap.appendChild(addNewVendorBtn);
        }
        
        const header = document.createElement('h1');
        header.classList.add('viewHeading');
        header.textContent = 'Vendors';
        viewMarkup.appendChild(header);
        viewMarkup.appendChild(vendorTable);
        viewMarkup.appendChild(btnWrap);     
        
        return viewMarkup;
    }
    function setPasswordFieldEyeIconAndEvents() { 
                 
        const evvPasswordContainer = document.getElementById('evvPassword').parentElement;
        evvPasswordContainer.classList.add('password-container');
        const eyeIcon1 = document.createElement('span');
        eyeIcon1.innerHTML = icons['show'];
        eyeIcon1.classList.add('eye');
        eyeIcon1.addEventListener("click", function () {
            const input = document.getElementById("evvPassword");
            if (input.type === "password") {
                input.type = "text";
                eyeIcon1.innerHTML = icons['eyeClose2'];
            } else {
                input.type = "password";
                eyeIcon1.innerHTML = icons['show'];
            }
        });
        evvPasswordContainer.appendChild(eyeIcon1);

        const eMARPasswordContainer = document.getElementById('eMARPassword').parentElement;
        eMARPasswordContainer.classList.add('password-container');
        const eyeIcon2 = document.createElement('span');
        eyeIcon2.innerHTML = icons['show'];
        eyeIcon2.classList.add('eye');
        eyeIcon2.addEventListener("click", function () {
            const input = document.getElementById("eMARPassword");
            if (input.type === "password") {
                input.type = "text";
                eyeIcon2.innerHTML = icons['eyeClose2'];
            } else {
                input.type = "password";
                eyeIcon2.innerHTML = icons['show'];
            }
        });
        eMARPasswordContainer.appendChild(eyeIcon2);
    }
    return {
        getView,        
    }
})();